/**
 * ChapterEyebrow — small uppercase tracked-out caption with optional roman
 * numeral and em-dash separator. The opening note for every editorial section.
 *
 * @example
 *   <ChapterEyebrow chapter="I" label="The Studio" />
 *   //  ▸  CHAPTER I — THE STUDIO
 *
 *   <ChapterEyebrow label="Featured Edits" tone="cream" />
 *   //  ▸  FEATURED EDITS
 */
import React from "react";

const TONE = {
  gold: "text-[color:var(--gold-base)]",
  cream: "text-[color:var(--cream)]",
  charcoal: "text-[color:var(--charcoal)]",
};

export default function ChapterEyebrow({
  chapter,
  label,
  tone = "gold",
  as: As = "p",
  className = "",
  ...rest
}) {
  const safe = TONE[tone] || TONE.gold;
  return (
    <As
      className={`ed-eyebrow ${safe} inline-flex items-baseline gap-[0.6em] ${className}`}
      {...rest}
    >
      {chapter ? (
        <>
          <span>{`Chapter ${chapter}`.toUpperCase()}</span>
          <span aria-hidden="true" className="opacity-70">—</span>
        </>
      ) : null}
      <span>{String(label).toUpperCase()}</span>
    </As>
  );
}
